import { createSelector } from 'reselect';

export const selectGolfSchools = createSelector(
  state => state.subscription.golfSchools.schools,
  schools => (schools ? schools.toJS() : null)
);

export const selectActiveGolfSchool = createSelector(
  [(state, id) => state.subscription.golfSchools.schools, (state, id) => id],
  (schools, id) => {
    if (schools.get('loaded') && id) {
      const activeGolfSchool = schools.get('data').find(school => school.get('id') === parseInt(id, 10));

      return activeGolfSchool ? activeGolfSchool.toJS() : null;
    }
    return null;
  }
);



// WEBPACK FOOTER //
// ./src/subscription/coaching/golf-schools/redux/selectors.js